import { AfterContentInit, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UsuarioAutorizacoes } from 'src/app/models/usuario.autorizacoes.model';
import { ClasseEquipamentoService } from 'src/app/services/classe-equipamento.service';
import { UsuarioService } from 'src/app/services/usuario.service';
import Swal from 'sweetalert2';
import { CommandResult } from '../../domain/commandResult';
import { ClasseEquipamento, TipoDeEquipamento } from '../../domain/domain.model';
import { TipoEquipamentoService } from 'src/app/services/tipo-equipamento.service';
import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'app-classe-equipamento',
  templateUrl: './classe-equipamento.component.html',
  styleUrls: ['./classe-equipamento.component.sass']
})
export class ClasseEquipamentoComponent implements OnInit, AfterContentInit {

  constructor(
    private usuarioService: UsuarioService,
    private formBuilder: FormBuilder,
    private classeEquipamentoService: ClasseEquipamentoService,
    private tipoEquipamentoService: TipoEquipamentoService,
    private toastr: ToastrService

  ) { }

  public cadastrados: ClasseEquipamento[] = [];

  public form: FormGroup = null;

  public isEditing = false;
  public isProcessing = false;
  public isLoading = false;

  public autorizacoes: UsuarioAutorizacoes;

  ngAfterContentInit(): void {
    this.autorizacoes = this.usuarioService.getAutorizacoesJanelaPorRota('classe-equipamento');
  }

  ngOnInit() {
    this.getCadastrados();
    this.resetForm(); // instancia o formulário utilizado (formGroup)
  }
  
  public resetForm(): void {
    this.form = this.formBuilder.group(
      {
        id: [0],
        descricao: ['', [Validators.required, Validators.maxLength(100)]],
      }
    );
  }

  public getCadastrados() {
    this.classeEquipamentoService.getAll().subscribe(
      (response: ClasseEquipamento[]) => this.cadastrados = response
    )
  }

  public resetFormParcial(): void {
    this.isEditing = false;
    this.isProcessing = false;
    this.isLoading = false;

    this.resetForm();
    //this.form.markAsUntouched();
  }

  public reset(): void {
    this.isEditing = false;
    this.isProcessing = false;
    this.isLoading = false;
    this.resetForm();
    this.cadastrados = [];
  }

  public getById(id: number): void {

    this.resetFormParcial();
    this.isProcessing = true;

    this.classeEquipamentoService.getById(id).subscribe(

      (response: ClasseEquipamento) => {

        this.form.get('id').setValue(response.id);
        this.form.get('descricao').setValue(response.descricao);

        this.isEditing = true;
      },
      (exception: any) => {
        this.showErrorExecption(exception);
        this.isProcessing = false;
      },
      () => this.isProcessing = false
    );
  }

  public submit(): void {

    this.isProcessing = true;


    this.classeEquipamentoService.isUniqueDescricao(this.form.get('descricao').value, this.form.get('id').value).subscribe(

      (isUniqueDescricao: boolean) => {

        if (isUniqueDescricao) {
          this.save();
        } else {
          this.form.get('descricao').setErrors({ isNotUniqueDescricao: true });
          this.isProcessing = false;
        }
      },
      (exception: any) => {
        this.showErrorExecption(exception);
	      this.isProcessing = false
      },
      () => this.isProcessing = false
    );

  }



  public save() {

    this.classeEquipamentoService.save(this.form.value).subscribe(

      (response: CommandResult) => {

        if (response.success === true) {
          this.toastr.success(response.message);
          this.resetFormParcial();
          this.getCadastrados();
        } else {
          this.toastr.error(response.message);
        }
      },
      (exception: any) => {
        this.showErrorExecption(exception);
        this.isProcessing = false
      },
      () => this.isProcessing = false
    );

  }

  public questionDelete(id: number) {

    Swal({
      title: 'Excluir',
      text: 'Deseja excluir o item selecionado?',
      type: 'question',
      showCancelButton: true,
      cancelButtonText: 'Não',
      showConfirmButton: true,
      confirmButtonText: 'Sim',
      cancelButtonColor: '#d33',
      focusCancel: true
    }).then((result) => {
      if (result.value) {
        this.delete(id);
      }
    });

  }



  private delete(id: number): void {

    this.isProcessing = true;

    this.classeEquipamentoService.delete(id).subscribe(

      (response: CommandResult) => {

        if (response.success === true) {
          this.toastr.success(response.message);
          this.reset();
        } else {
          this.toastr.error(response.message);
        }
      },
      (exception: any) => {
        this.showErrorExecption(exception);
	      this.isProcessing = false
      },

      () => this.isProcessing = false

    );
  }


  private showErrorExecption(exception: any) {
    let msg = exception.message;
    if (Number(exception.status) === 0) { msg = 'A aplicação não conseguiu se conectar ao Servidor'; }
    if (Number(exception.status) === 500) { msg = 'O Servidor gerou um erro de processamento'; }
    this.toastr.error(`<b>Erro no Servidor</b><br /><br />status: <b>${exception.status}</b><br /><br />${msg}`);
  }

}
